export default __webpack_public_path__ + "static/media/Arrow-2.6aad31f9.svg";